import { SESSION_COOKIE } from '@/configs/serviceConstants';
import {
  EFL_CART_ID,
  EFL_PINCODE,
  EFL_POPULAR_LIST,
  EFL_RECENTLY_VIEWED_PRODUCTS,
  EFL_RECENT_SEARCH,
  EXISTING_PREXO_DETAILS,
  PREXO_MAPPING,
} from '@/constants/app';
import Cookies from './cookie';
import LocalStorage from './localStorage';
import SessionStorage from './sessionStorage';
import { D365_USER_ID, SHOW_PROFILE_TOAST } from '@/constants/profileManagement';

const COOKIES = [EFL_RECENTLY_VIEWED_PRODUCTS, SESSION_COOKIE, D365_USER_ID];

const LOCAL_STORAGE_TOKENS = [EFL_PINCODE, EFL_CART_ID, EXISTING_PREXO_DETAILS, PREXO_MAPPING];

const SESSION_STORAGE_TOKENS = [EFL_POPULAR_LIST, EFL_RECENT_SEARCH, SHOW_PROFILE_TOAST];

export const deleteLogoutTokens = () => {
  COOKIES.forEach((cookieName) => {
    Cookies.delete(cookieName);
  });
  LOCAL_STORAGE_TOKENS.forEach((localStorageTokens) => {
    LocalStorage.remove(localStorageTokens);
  });

  SESSION_STORAGE_TOKENS.forEach((sessionStorageTokens) => {
    SessionStorage.remove(sessionStorageTokens);
  });
};
